function init() {
  var searchOverlay = document.getElementById(
    "predictive-search-overlay-container"
  );

  var popup = document.querySelector("[data-popup-opened]");
  var popup2 = document.querySelector("[data-pswp]");

  var accordions = document.querySelectorAll("[data-toggle-content]");
  var cartOpeners = document.querySelectorAll("[data-cart-drawer-open]");

  var mobileNav = document.querySelector("[data-mobile-nav]");
  var mobileNavStateChangers = document.querySelectorAll(
    "[data-mobile-nav-trigger], [data-mobile-nav] [data-mobile-nav-close]"
  );

  if (document.querySelector("form .errors ul li")) {
    const errs = document.querySelector("form .errors ul").innerHTML;
    document.querySelector("form .errors ul").innerHTML = "";
    window.addEventListener("load", () => {
      document.querySelector("form .errors ul").innerHTML = errs;
      document.querySelector("form .errors ul li").closest(".errors").focus();
    });
  }

  if ("MutationObserver" in window) {
    if (searchOverlay) {
      var searchOverlayButtons = document.querySelectorAll(
        '[aria-controls="predictive-search-overlay-container"]'
      );
      var searchOverlayObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName === "class") {
            var isActive = searchOverlay.classList.contains(
              "predictive-search__overlay--active"
            );
            var ariaHidden = isActive ? "false" : "true";
            if (searchOverlay.getAttribute("aria-hidden") !== ariaHidden) {
              searchOverlay.setAttribute("aria-hidden", ariaHidden);
              searchOverlayButtons.forEach(function (button) {
                button.setAttribute(
                  "aria-expanded",
                  isActive ? "true" : "false"
                );
              });
            }
          }
        });
      });

      searchOverlayObserver.observe(searchOverlay, {
        attributes: true,
        attributeFilter: ["class"],
      });

      var searchResults = searchOverlay.querySelector("[data-results-wrapper]");

      var searchResultsObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          var numContainer = searchResults.querySelector(
            "[data-results-number]"
          );
          if (
            mutation.target === numContainer ||
            mutation.target.closest("[data-results-number]")
          ) {
            return;
          }
          if (numContainer) {
            var results = searchResults.querySelectorAll(
              ".search-results__product"
            );
            var numResults = results.length;
            requestAnimationFrame(() => {
              numContainer.innerHTML =
                numResults +
                " " +
                (numResults === 1
                  ? numContainer.dataset.single
                  : numContainer.dataset.multiple);
            });
          }
        });
      });

      searchResultsObserver.observe(searchResults, {
        childList: true,
        subtree: true,
      });
    }

    function removeAccordion(accordionParent) {
      var content = accordionParent.querySelector("[data-content]");
      var toggle = accordionParent.querySelector(
        "[data-toggle-content] button"
      );
      content.removeAttribute("aria-hidden");
      toggle.removeAttribute("aria-expanded");
      toggle.setAttribute("role", "none");
      toggle.setAttribute("tabindex", "-1");
    }

    function setUpAccordion(accordionParent) {
      var isActive = accordionParent.classList.contains("active");
      var ariaHidden = isActive ? "false" : "true";
      var content = accordionParent.querySelector("[data-content]");
      var toggle = accordionParent.querySelector(
        "[data-toggle-content] button"
      );
      content.setAttribute("aria-hidden", ariaHidden);
      toggle.setAttribute("aria-expanded", isActive ? "true" : "false");
      toggle.removeAttribute("role");
      toggle.removeAttribute("tabindex");
    }

    function accordionsOnlyOnMobile(accordionParent) {
      if (window.innerWidth > 576) {
        removeAccordion(accordionParent);
      } else {
        setUpAccordion(accordionParent);
      }
    }

    window.addEventListener("resize", function () {
      if (accordions) {
        accordions.forEach(function (accordion) {
          var accordionParent = accordion.parentElement;
          accordionsOnlyOnMobile(accordionParent);
        });
      }
    });

    if (accordions) {
      var accordionsObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName === "class") {
            accordionsOnlyOnMobile(mutation.target);
          }
        });
      });

      var index = 1;
      accordions.forEach(function (accordion) {
        var accordionParent = accordion.parentElement;
        var content = accordionParent.querySelector("[data-content]");
        if (!content.id) {
          content.id = "accordion-content-" + index;
        }
        accordion.setAttribute("aria-controls", content.id);
        accordionsOnlyOnMobile(accordionParent);
        accordionsObserver.observe(accordionParent, {
          attributes: true,
          attributeFilter: ["class"],
        });
        index++;
      });
    }

    var contactUsButton = document.querySelectorAll(
      '[onclick*="globo-formbuilder"]'
    );
    var contactUsForm = document.querySelectorAll(".globo-formbuilder");

    if (contactUsButton.length && contactUsForm.length) {
      var contactUsObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName === "style") {
            var form = mutation.target;
            var formID = form.dataset.id;
            var isActive = form.style.display !== "none";

            Array.from(contactUsButton)
              .filter(function (btn) {
                return btn.getAttribute("onclick").includes(formID);
              })
              .forEach(function (btn) {
                btn.setAttribute("aria-expanded", isActive ? "true" : "false");
              });
          }
        });
      });

      Array.from(contactUsForm).forEach(function (form) {
        contactUsObserver.observe(form, {
          attributes: true,
          attributeFilter: ["style"],
        });

        var formID = form.dataset.id;
        Array.from(contactUsButton)
          .filter(function (btn) {
            return btn.getAttribute("onclick").includes(formID);
          })
          .forEach(function (btn) {
            btn.setAttribute("aria-controls", form.id);
            btn.setAttribute("aria-expanded", "false");
          });
      });
    }

    var globoFormsIntervalTries = 0;
    var globoFormsInterval = setInterval(function () {
      var globoForms = document.querySelectorAll(".globo-formbuilder");

      Array.from(globoForms).forEach(function (form) {
        Array.from(form.querySelectorAll("input")).forEach(function (input) {
          if (input.getAttribute("data-type") === "email") {
            input.setAttribute("autocomplete", "email");
            clearInterval(globoFormsInterval);
          }

          if (input.getAttribute("data-type") === "name") {
            input.setAttribute("autocomplete", "name");
            clearInterval(globoFormsInterval);
          }
        });
      });

      globoFormsIntervalTries++;
      if (globoFormsIntervalTries > 10) {
        clearInterval(globoFormsInterval);
      }
    }, 2500);

    if (cartOpeners.length) {
      var cartDrawer = document.querySelector("[data-cart-drawer]");
      if (cartDrawer) {
        var cartObserver = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (mutation.attributeName === "data-animation-state") {
              var isActive =
                mutation.target.getAttribute("data-animation-state") === "open";
              var ariaHidden = isActive ? "false" : "true";

              [
                "shopify-section-footer",
                "main-content",
                "shopify-section-header",
              ].forEach(function (id) {
                document
                  .getElementById(id)
                  .setAttribute("aria-hidden", isActive ? "true" : "false");
              });

              cartDrawer.setAttribute("aria-hidden", ariaHidden);
              cartOpeners.forEach(function (button) {
                button.setAttribute(
                  "aria-expanded",
                  isActive ? "true" : "false"
                );
              });
            }
          });
        });

        cartObserver.observe(cartDrawer, {
          attributes: true,
          attributeFilter: ["data-animation-state"],
        });
      }
    }

    if (mobileNavStateChangers.length && mobileNav) {
      var mobileNavObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName === "data-open") {
            var isActive = mutation.target.getAttribute("data-open") === "true";
            var ariaHidden = isActive ? "false" : "true";
            mobileNav.setAttribute("aria-hidden", ariaHidden);
            mobileNavStateChangers.forEach(function (button) {
              button.setAttribute("aria-expanded", isActive ? "true" : "false");
            });
          }
        });
      });

      mobileNavObserver.observe(mobileNav, {
        attributes: true,
        attributeFilter: ["data-open"],
      });
    }

    if (popup) {
      var currentActiveElement = null;
      var popupObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName === "data-popup-opened") {
            var isActive = popup.getAttribute("data-popup-opened") === "true";
            if (isActive) {
              currentActiveElement = document.activeElement;
              popup.focus();
            } else {
              if (currentActiveElement) {
                currentActiveElement.focus();
                currentActiveElement = null;
              }
            }
          }
        });
      });
      popupObserver.observe(popup, {
        attributes: true,
        attributeFilter: ["data-popup-opened"],
      });
    }

    if (popup2) {
      var currentActiveElement2 = null;
      var productGalleryImageTriggers = document.querySelectorAll(
        "[data-product-gallery-modal]"
      );

      if (productGalleryImageTriggers.length > 0) {
        productGalleryImageTriggers.forEach(function (trigger) {
          trigger.addEventListener("click", function (event) {
            currentActiveElement2 = event.currentTarget;
          });
        });
        var popup2Observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (mutation.attributeName === "aria-hidden") {
              var isActive = popup2.getAttribute("aria-hidden") === "false";
              if (!isActive) {
                if (currentActiveElement2) {
                  currentActiveElement2.focus();
                  currentActiveElement2 = null;
                }
              }
            }
          });
        });
        popup2Observer.observe(popup2, {
          attributes: true,
          attributeFilter: ["aria-hidden"],
        });
      }
    }

    var cartItemCount = document.querySelector("[data-header-cart-count]");
    var cartIcon = document.querySelector(".header-controls__cart");

    if (cartItemCount && cartIcon) {
      var cartLabelOne = cartIcon.getAttribute("data-label-one");
      var cartLabelOther = cartIcon.getAttribute("data-label-other");
      var cartItemCountObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function () {
          var count = parseInt(cartItemCount.innerText, 10);
          cartIcon.setAttribute(
            "aria-label",
            count === 1 ? cartLabelOne : cartLabelOther.replace("1000", count)
          );
        });
      });

      cartItemCountObserver.observe(cartItemCount, {
        characterData: true,
        attributes: false,
        childList: true,
        subtree: true,
      });
    }
  }

  if (window.Pristine) {
    var index = 1;
    [
      ".registration-form form",
      ".reset-password form",
      "#recover-password form",
      ".login-template__form form",
    ].forEach(function (selector) {
      var form = document.querySelector(selector);
      if (form) {
        var formStatus = document.createElement("div");
        var formStatusID = "form-status-" + index;
        formStatus.setAttribute("id", formStatusID);
        formStatus.setAttribute("role", "alert");
        formStatus.setAttribute("aria-atomic", "true");
        formStatus.setAttribute("tabindex", "-1");
        formStatus.classList.add("errors");
        formStatus.style.display = "none";
        formStatus.innerHTML = "<ul><li></li></ul>";
        form.prepend(formStatus);

        form.noValidate = true;

        var pristine = new Pristine(form);

        form.addEventListener("submit", function (e) {
          e.preventDefault();

          // check if the form is valid
          var valid = pristine.validate(); // returns true or false

          if (valid) {
            formStatus.style.display = "none";
            form.submit();
          } else {
            e.stopImmediatePropagation();

            formStatus.querySelector("li").innerText =
              "Form submitted with errors. Please fix the errors and try again.";

            formStatus.style.display = "block";

            requestAnimationFrame(function () {
              form.querySelector("#" + formStatusID).focus();
            });
          }
        });

        index++;
      }
    });

    window.addEventListener("load", () => {
      var contactUsForm = document.querySelector(".globo-form form");

      if (contactUsForm) {
        contactUsForm
          .querySelectorAll(".globo-form-control")
          .forEach((group) => {
            var message = group.querySelector(".messages");
            var input = group.querySelector(
              ".globo-form-input input, textarea, .globo-form-input select"
            );

            if (message && input) {
              message.setAttribute("role", "alert");
              message.setAttribute("aria-live", "off");
              message.id = input.id + "-message";
              input.setAttribute("aria-describedby", message.id);
            }
          });

        var formStatus = document.createElement("div");
        var formStatusID = "form-status-contact-us";
        formStatus.setAttribute("id", formStatusID);
        formStatus.setAttribute("role", "alert");
        formStatus.setAttribute("aria-atomic", "true");
        formStatus.setAttribute("tabindex", "-1");
        formStatus.classList.add("errors", "tms");
        formStatus.style.display = "none";
        formStatus.innerHTML = "<ul><li></li></ul>";
        contactUsForm.querySelector(".content").prepend(formStatus);

        contactUsForm.addEventListener("submit", function () {
          setTimeout(() => {
            requestAnimationFrame(() => {
              if (
                contactUsForm.querySelector(".globo-form-control.has-error")
              ) {
                formStatus.querySelector("li").innerText =
                  "Form submitted with errors. Please fix the errors and try again.";

                formStatus.style.display = "block";
                contactUsForm.querySelector("#" + formStatusID).focus();
              } else {
                formStatus.style.display = "none";
              }
            });
          });
        });
      }
    });
  }

  if (window.sessionStorage.getItem("set-focus-grid-top") === "true") {
    window.sessionStorage.removeItem("set-focus-grid-top");
    window.addEventListener("load", () => {
      document
        .querySelector(
          ".collection-page__list .product-thumbnail:first-child a"
        )
        .focus();
    });
  } else {
    window.addEventListener("load", () => {
      if (document.querySelector(".cart-template__empty")) {
        document.querySelector(".cart-template__empty").focus();
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", init);
